import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { questions } from '../data/faq';
export function FAQ() {
  const [open, setOpen] = useState(0);
  return <section className="bg-white py-20" aria-labelledby="faq-title" data-id="element-72" data-mp="1he2wzy8t5mf4">
      <div className="mx-auto max-w-3xl px-4" data-id="element-73" data-mp="1cf9nsi0k0hkr">
        <p className="mb-3 text-center font-mono text-[11px] font-bold uppercase tracking-[.2em] text-steel" data-id="element-74" data-mp="1ccdp2rgvtov9">Resolvemos tus dudas</p>
        <h2 id="faq-title" className="text-balance text-center text-3xl font-extrabold uppercase text-ink md:text-4xl" data-id="element-75" data-mp="252m8emn5mfbf">Preguntas frecuentes</h2>
        <div className="mt-10 space-y-3" data-id="element-76" data-mp="202hqcs6llcj3">
          {questions.map(([question, answer], index) => {
          const isOpen = index === open;
          return <article key={question} className="overflow-hidden rounded-md border border-line bg-mist" data-id="element-77" data-mp="op5rkvpp3k3s" data-mpi={index}>
                <h3 data-id="element-78" data-mp="jorjjdo3ga5r">
                  <button type="button" className="flex w-full items-center justify-between gap-5 px-5 py-5 text-left font-bold text-ink focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/45 sm:px-6" onClick={() => setOpen(isOpen ? -1 : index)} aria-expanded={isOpen} data-id="element-79" data-mp="jo9h1zau8zpe">
                    <span data-id="element-80" data-mp="1fnlx5dl7dx5c">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-steel transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-81" data-mp="1fqgkpdzijy2z" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-82" data-mp="s0vzspjsuqr2">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-83" data-mp="wynqxhcme8u7">
                      <p className="border-t border-line px-5 py-4 leading-relaxed text-muted sm:px-6" data-id="element-84" data-mp="2pny69pqjqro3">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </article>;
        })}
        </div>
      </div>
    </section>;
}